module.exports = __webpack_public_path__ + "img/w14.f975bb4d.svg";